import logo from "../assets/images/logo.png";

export const siteSettings = {
  title: "U Hub",
  siteName: "U Hub",

  description: "U Hub is a platform for print designs, part of the UE Group.",

  author: {
    name: "Unbound Europe",
    website: "https://unboundeurope.com",
  },

  logo: logo,

  translatedInputs: {
    supportedLanguages: ["en", "nl", "de"],
    defaultLanguage: "en",
  },

  tables: {
    projects: {
      paginationPageSize: 10,

      defaultPageSize: {
        key: 10,
        label: 10,
      },
      pageSizeOptions: [
        {
          key: 5,
          label: 5,
        },
        {
          key: 10,
          label: 10,
        },
        {
          key: 20,
          label: 20,
        },
        {
          key: 30,
          label: 30,
        },
        {
          key: 50,
          label: 50,
        },

        {
          key: 70,
          label: 70,
        },

        {
          key: 100,
          label: 100,
        },
      ],

      searchByOptions: [
        {
          key: "_id",
          label: "Internal Id",
          regex: false,
          objectId: true,
        },
        {
          key: "name",
          label: "Name",
          regex: true,
          objectId: false,
        },
        {
          key: "slug",
          label: "Slug",
          regex: true,
          objectId: false,
        },

        {
          key: "projectCreatedBy",
          label: "Created By (ID)",
          regex: false,
          objectId: false, // fb uid
        },

        {
          key: "apiKeyGeneratedBy",
          label: "API Generated By (ID)",
          regex: false,
          objectId: false, // fb uid
        },
      ],

      sortByOptions: [
        {
          key: "createdAt",
          label: "Created At",
          dir: -1, // 1 or -1. 1 for ascending, -1 for descending.
        },
        {
          key: "createdAt",
          label: "Created At",
          dir: 1, // 1 or -1. 1 for ascending, -1 for descending.
        },

        {
          key: "updatedAt",
          label: "Updated At",
          dir: -1, // 1 or -1. 1 for ascending, -1 for descending.
        },
        {
          key: "updatedAt",
          label: "Updated At",
          dir: 1, // 1 or -1. 1 for ascending, -1 for descending.
        },

        {
          key: "name",
          label: "Name",
          dir: -1, // 1 or -1. 1 for ascending, -1 for descending.
        },
        {
          key: "name",
          label: "Name",
          dir: 1, // 1 or -1. 1 for ascending, -1 for descending.
        },

        {
          key: "slug",
          label: "Slug",
          dir: -1, // 1 or -1. 1 for ascending, -1 for descending.
        },

        {
          key: "slug",
          label: "Slug",
          dir: 1, // 1 or -1. 1 for ascending, -1 for descending.
        },
      ],
    },

    categories: {
      paginationPageSize: 10,

      defaultPageSize: {
        key: 10,
        label: 10,
      },
      pageSizeOptions: [
        {
          key: 5,
          label: 5,
        },
        {
          key: 10,
          label: 10,
        },
        {
          key: 20,
          label: 20,
        },
        {
          key: 30,
          label: 30,
        },
        {
          key: 50,
          label: 50,
        },

        {
          key: 70,
          label: 70,
        },

        {
          key: 100,
          label: 100,
        },
      ],

      searchByOptions: [
        {
          key: "_id",
          label: "Internal Id",
          regex: false,
          objectId: true,
        },
        {
          key: "internalName",
          label: "Internal Name",
          regex: true,
          objectId: false,
        },
        {
          key: "slug",
          label: "Slug",
          regex: true,
          objectId: false,
        },
      ],

      sortByOptions: [
        {
          key: "createdAt",
          label: "Created At",
          dir: -1, // 1 or -1. 1 for ascending, -1 for descending.
        },
        {
          key: "createdAt",
          label: "Created At",
          dir: 1, // 1 or -1. 1 for ascending, -1 for descending.
        },

        {
          key: "updatedAt",
          label: "Updated At",
          dir: -1, // 1 or -1. 1 for ascending, -1 for descending.
        },
        {
          key: "updatedAt",
          label: "Updated At",
          dir: 1, // 1 or -1. 1 for ascending, -1 for descending.
        },

        {
          key: "internalName",
          label: "Internal Name",
          dir: -1, // 1 or -1. 1 for ascending, -1 for descending.
        },
        {
          key: "internalName",
          label: "Internal Name",
          dir: 1, // 1 or -1. 1 for ascending, -1 for descending.
        },

        {
          key: "slug",
          label: "Slug",
          dir: -1, // 1 or -1. 1 for ascending, -1 for descending.
        },

        {
          key: "slug",
          label: "Slug",
          dir: 1, // 1 or -1. 1 for ascending, -1 for descending.
        },
      ],
    },

    subcategories: {
      paginationPageSize: 10,

      defaultPageSize: {
        key: 10,
        label: 10,
      },
      pageSizeOptions: [
        {
          key: 5,
          label: 5,
        },
        {
          key: 10,
          label: 10,
        },
        {
          key: 20,
          label: 20,
        },
        {
          key: 30,
          label: 30,
        },
        {
          key: 50,
          label: 50,
        },

        {
          key: 70,
          label: 70,
        },

        {
          key: 100,
          label: 100,
        },
      ],

      searchByOptions: [
        {
          key: "_id",
          label: "Internal Id",
          regex: false,
          objectId: true,
        },
        {
          key: "internalName",
          label: "Internal Name",
          regex: true,
          objectId: false,
        },
        {
          key: "slug",
          label: "Slug",
          regex: true,
          objectId: false,
        },
      ],

      sortByOptions: [
        {
          key: "createdAt",
          label: "Created At",
          dir: -1, // 1 or -1. 1 for ascending, -1 for descending.
        },
        {
          key: "createdAt",
          label: "Created At",
          dir: 1, // 1 or -1. 1 for ascending, -1 for descending.
        },

        {
          key: "updatedAt",
          label: "Updated At",
          dir: -1, // 1 or -1. 1 for ascending, -1 for descending.
        },
        {
          key: "updatedAt",
          label: "Updated At",
          dir: 1, // 1 or -1. 1 for ascending, -1 for descending.
        },

        {
          key: "internalName",
          label: "Internal Name",
          dir: -1, // 1 or -1. 1 for ascending, -1 for descending.
        },
        {
          key: "internalName",
          label: "Internal Name",
          dir: 1, // 1 or -1. 1 for ascending, -1 for descending.
        },

        {
          key: "slug",
          label: "Slug",
          dir: -1, // 1 or -1. 1 for ascending, -1 for descending.
        },

        {
          key: "slug",
          label: "Slug",
          dir: 1, // 1 or -1. 1 for ascending, -1 for descending.
        },
      ],
    },

    templates: {
      paginationPageSize: 10,

      gridColumnsOptions: [
        {
          key: 2,
          label: 2,
        },
        {
          key: 3,
          label: 3,
        },

        {
          key: 4,
          label: 4,
        },
        {
          key: 5,
          label: 5,
        },
        {
          key: 6,
          label: 6,
        },
      ],

      defaultPageSize: {
        key: 10,
        label: 10,
      },
      pageSizeOptions: [
        {
          key: 5,
          label: 5,
        },
        {
          key: 10,
          label: 10,
        },
        {
          key: 20,
          label: 20,
        },
        {
          key: 30,
          label: 30,
        },
        {
          key: 50,
          label: 50,
        },

        {
          key: 70,
          label: 70,
        },

        {
          key: 100,
          label: 100,
        },
      ],

      searchByOptions: [
        {
          key: "_id",
          label: "Internal Id",
          regex: false,
          objectId: true,
        },
        {
          key: "internalName",
          label: "Internal Name",
          regex: true,
          objectId: false,
        },
        {
          key: "projectIds",
          label: "Project Id",
          regex: false,
          objectId: true,
        },
        {
          key: "categoryIds",
          label: "Category Id",
          regex: false,
          objectId: true,
        },
        {
          key: "subcategoryIds",
          label: "Subcategory Id",
          regex: false,
          objectId: true,
        },

        {
          key: "tags",
          label: "Tag",
          regex: true,
          objectId: false,
        },
        {
          key: "slug",
          label: "Slug",
          regex: true,
          objectId: false,
        },
      ],

      sortByOptions: [
        {
          key: "createdAt",
          label: "Created At",
          dir: -1, // 1 or -1. 1 for ascending, -1 for descending.
        },
        {
          key: "createdAt",
          label: "Created At",
          dir: 1, // 1 or -1. 1 for ascending, -1 for descending.
        },

        {
          key: "updatedAt",
          label: "Updated At",
          dir: -1, // 1 or -1. 1 for ascending, -1 for descending.
        },
        {
          key: "updatedAt",
          label: "Updated At",
          dir: 1, // 1 or -1. 1 for ascending, -1 for descending.
        },

        {
          key: "internalName",
          label: "Internal Name",
          dir: -1, // 1 or -1. 1 for ascending, -1 for descending.
        },
        {
          key: "internalName",
          label: "Internal Name",
          dir: 1, // 1 or -1. 1 for ascending, -1 for descending.
        },

        {
          key: "slug",
          label: "Slug",
          dir: -1, // 1 or -1. 1 for ascending, -1 for descending.
        },

        {
          key: "slug",
          label: "Slug",
          dir: 1, // 1 or -1. 1 for ascending, -1 for descending.
        },
      ],
    },

    sets: {
      paginationPageSize: 10,

      defaultPageSize: {
        key: 10,
        label: 10,
      },

      pageSizeOptions: [
        {
          key: 5,
          label: 5,
        },
        {
          key: 10,
          label: 10,
        },
        {
          key: 20,
          label: 20,
        },
        {
          key: 30,
          label: 30,
        },
        {
          key: 50,
          label: 50,
        },
        {
          key: 70,
          label: 70,
        },

        {
          key: 100,
          label: 100,
        },
      ],

      searchByOptions: [
        {
          key: "_id",
          label: "Internal Id",
          regex: false,
          objectId: true,
        },

        {
          key: "internalName",
          label: "Internal Name",
          regex: true,
          objectId: false,
        },

        {
          key: "templateIds",
          label: "Template Id",
          regex: false,
          objectId: true,
        },

        {
          key: "printLocations",
          label: "Print Location",
          regex: false,
          objectId: true,
        },

        {
          key: "slug",
          label: "Slug",
          regex: true,
          objectId: false,
        },
      ],

      sortByOptions: [
        {
          key: "createdAt",
          label: "Created At",
          dir: -1, // 1 or -1. 1 for ascending, -1 for descending.
        },
        {
          key: "createdAt",
          label: "Created At",
          dir: 1, // 1 or -1. 1 for ascending, -1 for descending.
        },

        {
          key: "updatedAt",
          label: "Updated At",
          dir: -1, // 1 or -1. 1 for ascending, -1 for descending.
        },
        {
          key: "updatedAt",
          label: "Updated At",
          dir: 1, // 1 or -1. 1 for ascending, -1 for descending.
        },

        {
          key: "internalName",
          label: "Internal Name",
          dir: -1, // 1 or -1. 1 for ascending, -1 for descending.
        },
        {
          key: "internalName",
          label: "Internal Name",
          dir: 1, // 1 or -1. 1 for ascending, -1 for descending.
        },

        {
          key: "slug",
          label: "Slug",
          dir: -1, // 1 or -1. 1 for ascending, -1 for descending.
        },

        {
          key: "slug",
          label: "Slug",
          dir: 1, // 1 or -1. 1 for ascending, -1 for descending.
        },
      ],
    },

    printLocations: {
      paginationPageSize: 10,

      defaultPageSize: {
        key: 10,
        label: 10,
      },
      pageSizeOptions: [
        {
          key: 5,
          label: 5,
        },
        {
          key: 10,
          label: 10,
        },
        {
          key: 20,
          label: 20,
        },
        {
          key: 30,
          label: 30,
        },
        {
          key: 50,
          label: 50,
        },

        {
          key: 70,
          label: 70,
        },

        {
          key: 100,
          label: 100,
        },
      ],

      searchByOptions: [
        {
          key: "_id",
          label: "Internal Id",
          regex: false,
          objectId: true,
        },
        {
          key: "internalName",
          label: "Internal Name",
          regex: true,
          objectId: false,
        },
        {
          key: "slug",
          label: "Slug",
          regex: true,
          objectId: false,
        },
      ],

      sortByOptions: [
        {
          key: "createdAt",
          label: "Created At",
          dir: -1, // 1 or -1. 1 for ascending, -1 for descending.
        },
        {
          key: "createdAt",
          label: "Created At",
          dir: 1, // 1 or -1. 1 for ascending, -1 for descending.
        },

        {
          key: "updatedAt",
          label: "Updated At",
          dir: -1, // 1 or -1. 1 for ascending, -1 for descending.
        },
        {
          key: "updatedAt",
          label: "Updated At",
          dir: 1, // 1 or -1. 1 for ascending, -1 for descending.
        },

        {
          key: "internalName",
          label: "Internal Name",
          dir: -1, // 1 or -1. 1 for ascending, -1 for descending.
        },
        {
          key: "internalName",
          label: "Internal Name",
          dir: 1, // 1 or -1. 1 for ascending, -1 for descending.
        },

        {
          key: "slug",
          label: "Slug",
          dir: -1, // 1 or -1. 1 for ascending, -1 for descending.
        },

        {
          key: "slug",
          label: "Slug",
          dir: 1, // 1 or -1. 1 for ascending, -1 for descending.
        },
      ],
    },

    users: {
      paginationPageSize: 10,

      defaultPageSize: {
        key: 10,
        label: 10,
      },

      pageSizeOptions: [
        {
          key: 5,
          label: 5,
        },
        {
          key: 10,
          label: 10,
        },
        {
          key: 20,
          label: 20,
        },
        {
          key: 30,
          label: 30,
        },
        {
          key: 50,
          label: 50,
        },

        {
          key: 70,
          label: 70,
        },

        {
          key: 100,
          label: 100,
        },
      ],

      searchByOptions: [
        {
          key: "_id",
          label: "Internal Id",
          regex: false,
          objectId: false, // fb uid
        },
        {
          key: "email",
          label: "Email",
          regex: true,
          objectId: false,
        },
        {
          key: "firstName",
          label: "First Name",
          regex: true,
          objectId: false,
        },
        {
          key: "lastName",
          label: "Last Name",
          regex: true,
          objectId: false,
        },
      ],

      sortByOptions: [
        {
          key: "createdAt",
          label: "Created At",
          dir: -1, // 1 or -1. 1 for ascending, -1 for descending.
        },
        {
          key: "createdAt",
          label: "Created At",
          dir: 1, // 1 or -1. 1 for ascending, -1 for descending.
        },

        {
          key: "updatedAt",
          label: "Updated At",
          dir: -1, // 1 or -1. 1 for ascending, -1 for descending.
        },
        {
          key: "updatedAt",
          label: "Updated At",
          dir: 1, // 1 or -1. 1 for ascending, -1 for descending.
        },

        {
          key: "email",
          label: "Email",
          dir: -1, // 1 or -1. 1 for ascending, -1 for descending.
        },

        {
          key: "email",
          label: "Email",
          dir: 1, // 1 or -1. 1 for ascending, -1 for descending.
        },

        {
          key: "firstName",
          label: "First Name",
          dir: -1, // 1 or -1. 1 for ascending, -1 for descending.
        },
        {
          key: "firstName",
          label: "First Name",
          dir: 1, // 1 or -1. 1 for ascending, -1 for descending.
        },

        {
          key: "lastName",
          label: "Last Name",
          dir: -1, // 1 or -1. 1 for ascending, -1 for descending.
        },
        {
          key: "lastName",
          label: "Last Name",
          dir: 1, // 1 or -1. 1 for ascending, -1 for descending.
        },
      ],
    },
  },
};
